/* eslint-disable no-param-reassign */
/* eslint-disable no-multi-assign */
/* eslint-disable no-console */
import {
  useCallback,
  useReducer,
  useRef,
  useMemo,
  useState,
  useEffect,
} from "react";
// import { useDispatch, useSelector } from "react-redux";

// export function useRedux(stateMappToProps) {
//   const dispatch = useDispatch();

//   return {
//     ...useSelector(stateMappToProps, [dispatch]),
//     dispatch,
//   };
// }

/**
 * @description useCustomReducer only added the logging functionality
 *  to the build-in reducer
 * @param {*} reducerFn reducerFn is a reducer function which handles
 *   all state reducing cases
 * @param {*} initialState initial state reduer
 * @param {*} enableLogger Boolean use for enabling/disabling logs during state change
 */
export function useCustomReducer(reducerFn, initialState, enableLogger) {
  const [state, dispatch] = useReducer(reducerFn, initialState);
  // We use preState for storing the previous state and storing actiontype
  // when if the user dispatch any action with type to in logging
  const preState = useRef();

  // @Note we added empty dependency for dispatchWithLogging callback
  // because user can use it exactly the same way as normal dispatch
  // of useReducer for dependencies.
  const dispatchWithLogging = useCallback((action) => {
    if (typeof action === "function")
      return action(dispatchWithLogging, () => preState.state);

    const actionType = typeof action === "object" ? action.type : action;

    preState.current.actions = preState.current.actions || [];
    preState.current.actions.push({ actionType, action });

    dispatch(action);
  }, []);

  // We separate the dispatch mechanism in case user do not want logging
  const customDispatch = enableLogger ? dispatchWithLogging : dispatch;

  // @Note after every dispatch state updation useMemo get called because
  // we added the state in dependencies.
  useMemo(
    function logStateAfterChange() {
      // we can pring the logs only in case user enable it and user update state
      if (!enableLogger || !preState.current) return;

      for (let i = 0; i < preState.current.actions?.length; i++) {
        const {
          actionType,
          state: previousState,
          action,
        } = preState.current.actions[i];
        console.groupCollapsed(`${actionType}`);
        console.log("%c Previous State", "color: red;", previousState);
        console.log("%c Action", "color: blue", action);
        console.log("%c Current State", "color: green", state);
        console.groupEnd();
      }

      // Reset the actions dispatching list
      preState.current.actions = [];
    },
    [state, enableLogger]
  );

  preState.current = { ...preState.current, state };

  return [state, customDispatch];
}

// future time from where countdown will start decreasing

export const useCountDown = (futureTime = new Date().getTime()) => {
  const setFutureTime = (time) => {
    futureTime = time;
  };

  const [time, setTime] = useState(futureTime - Date.now());

  // ref to store interval which we can clear out later
  // when stop changes through parent component (component that uses this hook)
  // causing the useEffect callback to trigger again
  const intervalRef = useRef(null);

  useEffect(() => {
    const interval = (intervalRef.current = setInterval(() => {
      if (futureTime - Date.now() > 0) {
        setTime(futureTime - Date.now());
      } else {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    }, 1000));

    return () => clearInterval(interval);
  }, [intervalRef, futureTime]);

  return { ...getReturnValues(time), setFutureTime };
};

const getReturnValues = (countDown) => {
  const days = Math.floor(countDown / (1000 * 60 * 60 * 24));
  const hours = Math.floor(
    (countDown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  );
  const minutes = Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((countDown % (1000 * 60)) / 1000);

  return { days, hours, minutes, seconds };
};
